import { ready } from 'core-utilities';
import React from 'react';
import { render } from 'react-dom';
import App from './App';

import '../../../css/gameSearch/gameSearch.scss';

const gamesSearchPageId = 'games-search-page';

ready(() => {
  render(<App />, document.getElementById(gamesSearchPageId));
});
